import * as Yup from 'yup';

export const registerSchema = Yup.object({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
    birthdate: Yup.date().required('Birthdate is required'),
    city: Yup.string().required('City is required'),
    country: Yup.string().required('Country is required'),
    grade: Yup.string().required('Grade is required'),
    sensei_name: Yup.string().required('Sensei name is required'),
    sayonaraParty: Yup.number(),
    tshirtSize: Yup.string(),
    danGrading: Yup.boolean(),
    participationType: Yup.string().required(
        'Please select a participation type',
    ),
    togkfMember: Yup.string()
        .oneOf(['yes', 'no'], 'Please specify if you are a TOGKF member')
        .required('Please specify if you are a TOGKF member'),
    federationName: Yup.string().when('togkfMember', {
        is: 'no',
        then: schema =>
            schema
                .trim()
                .required('Federation name is required')
                .min(1, 'Federation name is required'),
        otherwise: schema => schema.notRequired(),
    }),
    totalPrice: Yup.number(),
});
